<template>
  <div>
    <!-- contactBox -->
    <div class="contactBoxStyle" id="fourth">
      <h3>Contáctenos</h3>
      <p>Correo electrónico: servicio@credisol.pe</p>
      <p>Sitio web: www.credisol.pe</p>
      <p>
        Puedes consultar en nuestra página oficial en www.credisol.pe o llamar a
        su centro de atención telefónica al +51 17309229
      </p>
      <p>Horario de trabajo: 9:00 a 19:00 horas de lunes a viernes</p>
    </div>
    <!-- Información sobre nosotros -->
    <div
      class="contactBoxStyle"
      style="padding: 0.47rem 0.35rem 0.35rem"
      id="last"
    >
      <h3>Información sobre nosotros</h3>
      <p style="margin: 0">
        La mejor plataforma de préstamo en Perú, solicita un préstamo de hasta
        S/ 5,000 en menos de tres minutos. CrediSol es una empresa de servicios
        financieros con licencia en Perú. Es nuestra responsabilidad y
        obligación informar a nuestros usuarios de nuestra política de
        privacidad (https://www.credisol.pe/h5/privacidad.html). Si tiene alguna
        pregunta, no dude en ponerse en contacto con nosotros. Correo
        electrónico: servicio@credisol.pe.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.contactBoxStyle {
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.47rem 0.39rem 0.35rem;
  margin-top: 0.3rem;
  h3 {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.3rem;
  }
  p {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.26rem;
    color: #333333;
    margin-bottom: 0.2rem;
  }
}
</style>
